import styled from '@mui/material/styles/styled'
import Box from '@mui/material/Box'

export const VerticalLine = styled(Box, {
  name: 'VerticalLine',
  slot: 'Root',
  skipSx: true,
})`
  background-color: #19305a;
  width: 2px;
  height: 35px;
  margin: 0 4px;
  padding: 0;
`
